// extracted by mini-css-extract-plugin
export default {"videoFrame":"Home_videoFrame__YQtZl","iframeContainer":"Home_iframeContainer__fdi7E","highlight":"Home_highlight__-KVIr"};